import { render, staticRenderFns } from "./ConfirmBulkTransactionsUpdate.vue?vue&type=template&id=62c22c7e"
import script from "./ConfirmBulkTransactionsUpdate.vue?vue&type=script&lang=js"
export * from "./ConfirmBulkTransactionsUpdate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBulkTransactionsUpdate.vue?vue&type=style&index=0&id=62c22c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports